import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { Button } from 'frontend/js/modules/infra/dls/components/button/button';
import { t } from 'frontend/js/modules/infra/i18n';
import { showNotification } from 'frontend/js/app/common/helpers/notifications';
import { getViewerIdAndKind, useSession } from 'frontend/js/modules/infra/session';
import { useApiMutation } from 'frontend/js/modules/infra/api';
import { endpoints } from '../../../../network';
import { usePortalNode } from '../../../../hooks/use-portal-node';
export var TurnOffButton = function () {
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var mobileNode = usePortalNode('mobile-bottom-bar-portal');
    var desktopNode = usePortalNode('desktop-header-button-portal');
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    // TODO: Get values from actual API
    var campaignName = '';
    var subtype = '';
    var _a = useApiMutation({
        endpoint: endpoints.reactivateAutomatedCampaignMutation,
        options: {
            onSuccess: function (campaign) {
                showNotification({
                    title: '',
                    message: campaign.isEnabled
                        ? t('engage:automated.campaign_now_active', { campaignName: campaignName })
                        : t('engage:automated.campaign_now_inactive', { campaignName: campaignName }),
                    autoDismiss: 8,
                });
            },
        },
    }), reactivateAutomatedCampaign = _a.mutate, isLoading = _a.isLoading;
    var handleTurnOffCampaign = function () {
        reactivateAutomatedCampaign({
            isEnabled: false,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            subtype: subtype,
        });
    };
    if (isMobileOrSmaller) {
        if (!mobileNode) {
            return null;
        }
        return createPortal(_jsx(Button, { disabled: isLoading, variant: "primary", size: "default", onClick: handleTurnOffCampaign, fullWidth: true, children: t('engage:automated.turn_off_campaign') }), mobileNode);
    }
    if (!desktopNode) {
        return null;
    }
    return createPortal(_jsx(Button, { variant: "primary", size: "default", onClick: handleTurnOffCampaign, children: t('engage:automated.turn_off_campaign') }), desktopNode);
};
